import { startAuthentication, WebAuthnAbortService, } from '@simplewebauthn/browser';
import { AuthClientError, ClientErrorCode, mapWebAuthnError } from '../errors.js';
export function createLoginMethods(request, appId) {
    return {
        getConfig() {
            return request(`/auth/passkeys/config?appId=${encodeURIComponent(appId)}`);
        },
        /**
         * `signal` cancels the sign-in up to the moment the user picks a passkey: before the call,
         * during the options request, or during the browser prompt. Each rejects with
         * `PASSKEY_CANCELLED`. Once a passkey is picked, the verify request runs to completion.
         */
        async login(opts = {}) {
            const { useBrowserAutofill = false, signal } = opts;
            throwIfAborted(signal);
            const onAbort = () => WebAuthnAbortService.cancelCeremony();
            signal?.addEventListener('abort', onAbort);
            try {
                let optionsJSON;
                try {
                    optionsJSON = await request('/auth/passkeys/login/options', {
                        method: 'POST',
                        body: { appId },
                        signal,
                    });
                }
                catch (err) {
                    if (isAbortError(err)) {
                        throw cancelled();
                    }
                    throw err;
                }
                // An abort during the options request may land after fetch resolved; the ceremony's own
                // abort listener only cancels a ceremony that has already started.
                throwIfAborted(signal);
                let response;
                try {
                    response = await startAuthentication({ optionsJSON, useBrowserAutofill });
                }
                catch (err) {
                    throw mapWebAuthnError(err, 'get');
                }
                return await request('/auth/passkeys/login/verify', {
                    method: 'POST',
                    body: { appId, response },
                });
            }
            finally {
                signal?.removeEventListener('abort', onAbort);
            }
        },
    };
}
function cancelled() {
    return new AuthClientError(ClientErrorCode.PASSKEY_CANCELLED, 'Passkey sign-in was cancelled', 0);
}
function throwIfAborted(signal) {
    if (signal?.aborted) {
        throw cancelled();
    }
}
function isAbortError(err) {
    return typeof err === 'object' && err !== null && err.name === 'AbortError';
}
